import { useTranslation } from 'react-i18next';
import { Typography } from 'mobily-ui-library/lib';

import AppleLogo from '../../../assets/AppleCareLogo.svg';
import ACSupport from '../../../assets/ACSupport.svg';
import ACBattery from '../../../assets/ACBattery.svg';
import ACDamage from '../../../assets/ACDamage.svg';
import ACRepair from '../../../assets/ACRepair.svg';


import './AppleCare.scss';

interface AppleCareProps {
    rtl: boolean;
}

function AppleCare({ rtl }: AppleCareProps) {
    const { t } = useTranslation();
    // const [appleCovered, setAppleCovered] = useState(false);

    // const handleAppleCoverage = () => {
    //     setAppleCovered((prevState) => !prevState);
    // }

    return (
        <div className='DD__AppleCareSection'>
            <div className='DDAC__Head'>
                <img src={AppleLogo} alt='applecare-logo' />
                <Typography className='DDAC__Tag'>{t('new')}</Typography>
            </div>
            <div className='DDAC__Category'>
                <div className='DDAC__Info'>
                    <Typography rtl={rtl} className='DDAC__Title'>{t('Choose_AppleCare')}</Typography>
                    <Typography rtl={rtl} className='DDAC__Subtitle'>{t('AppleCare__subtitle')}</Typography>
                </div>

                <div className='DDAC__CoveredItems'>
                    <div className='DDAC__Item'>
                        <img src={ACDamage} alt='apple-damage' />
                        <Typography>{t("Damage_protection")}</Typography>
                    </div>
                    <div className='DDAC__Item'>
                        <img src={ACRepair} alt='apple-repair' />
                        <Typography>{t("Apple_repairs")}</Typography>
                    </div>
                    <div className='DDAC__Item'>
                        <img src={ACBattery} alt='apple-battery' />
                        <Typography>{t("Battery_warranty")}</Typography>
                    </div>
                    <div className='DDAC__Item'>
                        <img src={ACSupport} alt='apple-service' />
                        <Typography>{t("Priority_service")}</Typography>
                    </div>
                </div>

                {/* <div className='DDAC__AddCoverage'>
                    <div className={appleCovered ? 'DDAC__Button DDAC__active' : 'DDAC__Button'} onClick={handleAppleCoverage}>Add Coverage</div>
                </div> */}
            </div>
        </div>
    )
}

export default AppleCare